<template>
  <div class="donate_wrap">
    <div class="donate">
      <page-header class="not_main"></page-header>
      <div class="donate_content">

        <image-component :infoType="'donateBanner'"></image-component>

        <board-home-component :boardType="'primeDonate'"></board-home-component>

        <board-list-component :boardType="'donate'"></board-list-component>

      </div>
      <page-footer class="not_main"></page-footer>
    </div>
  </div>
</template>

<script>
import BoardListComponent from "@/components/board/BoardListComponent";
import ImageComponent from "@/components/information/ImageComponent";
import BoardHomeComponent from "@/components/board/BoardHomeComponent";

export default {
  name: "Donate",
  mixins: [],
  components: {BoardHomeComponent, ImageComponent, BoardListComponent},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {},
  watch: {},
}
</script>

<style scoped>

</style>